import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/** Performance Max in Gmail (mobile): inbox row with headline, description and a landscape creative below. */
@Component({
    selector: 'app-pmax-gmail-mobile-04',
    imports: [CommonModule, MobileFrameComponent],
    templateUrl: './gmail-mobile-04.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './gmail-mobile-04.component.scss'
})
export class PmaxGmailMobile04PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Row count for the skeleton inbox below the ad. */
  readonly inboxSkeletonRows = Array.from({ length: 4 });

  /** This placement's creative slot is the 1.91:1 landscape format. */
  readonly creativeFormat: CreativeFormat = 'landscape';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
